import React from "react";
import Hls from "hls.js";
import { Spin } from "antd";

class HLSPlayer extends React.Component {
    constructor(props) {
        super(props);
        this.videoRef = React.createRef();
        this.hls = null;
        this.state = {
            showVideo: false,
            loading: true
        };
        this.timeout = null;
    }

    componentDidMount() {
        let interval = 15000;
        if (this.props.interval) {
            interval = this.props.interval;
        }
        this.timeout = setTimeout(() => {
            this.setState({ showVideo: true }, this.initializeHLS);
        }, 15000);
    }

    componentWillUnmount() {
        if (this.hls) {
            this.hls.destroy();
        }
        clearTimeout(this.timeout);
    }

    initializeHLS = () => {
        const { src, isSingle, heightFactor } = this.props;
        //debugger
        console.log("Initializing HLS with source:", src, "isSingle:", isSingle);
        if (Hls.isSupported()) {
            this.hls = new Hls({
                liveSyncDurationCount: 6,
                liveMaxLatencyDurationCount: 12,
                maxLiveSyncPlaybackRate: 1.5,
                enableWorker: true,
                debug: true
            });
            this.hls.loadSource(src);
            this.hls.attachMedia(this.videoRef.current);

            this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
                this.setState({ loading: false });
            });

            this.hls.on(Hls.Events.ERROR, (event, data) => {
                console.error("HLS Error Event:", event);
                console.error("HLS Error Data:", data);

                console.error("Error type:", data.type);
                console.error("Error details:", data.details);
                console.error("Fatal:", data.fatal);

                this.setState({ loading: false }); // Stop loader on error
            });

        } else if (this.videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
            this.videoRef.current.src = src;
            this.setState({ loading: false });
        }
    };

    render() {
        const { showVideo, loading } = this.state;
        const { src, isSingle, heightFactor } = this.props;

        return (
            <div style={{ position: "relative", width: "100%" }}>
                {!showVideo && (
                    <div
                        style={{
                            width: "100%",
                            position: 'relative',
                            height: heightFactor,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#00000099"
                        }}
                    >
                        <Spin tip="Loading video..." />
                    </div>
                )}

                {showVideo && (
                    <video
                        ref={this.videoRef}
                        controls
                        autoPlay
                        muted
                        style={{ width: '100%', height: heightFactor, objectFit: 'fill', background: '#000' }}
                    />
                )}
            </div>
        );
    }
}

export default HLSPlayer;
